class AnnouncementTicker extends HTMLElement {
  constructor() {
    super();
    this.animationId = null;
    this.currentPosition = 0;
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.ticker-bar-wrapper');
    this.content = this.querySelector('.ticker-bar-content');
    
    if (!this.wrapper || !this.content) return;

    this.speed = parseFloat(this.dataset.speed) || 30;
    this.contentWidth = this.content.offsetWidth;
    this.pixelsPerSecond = this.contentWidth / this.speed;

    this.startAnimation();
  }

  startAnimation() {
    let lastTime = performance.now();
    
    const animate = (currentTime) => {
      const deltaTime = (currentTime - lastTime) / 1000;
      lastTime = currentTime;

      this.currentPosition -= this.pixelsPerSecond * deltaTime;

      if (Math.abs(this.currentPosition) >= this.contentWidth) {
        this.currentPosition = 0;
      }

      this.wrapper.style.transform = `translateX(${this.currentPosition}px)`;
      this.animationId = requestAnimationFrame(animate);
    };

    this.animationId = requestAnimationFrame(animate);
  }

  disconnectedCallback() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }
}

if (!customElements.get('announcement-ticker')) {
  customElements.define('announcement-ticker', AnnouncementTicker);
}